if (!customElements.get('tabbed-info')) {
class TabbedInfo extends HTMLElement {
  constructor() {
    super();
    this.tabContainer = this;
    this.tabButtons = this.querySelectorAll('.tabbed-info__tab-button');
    this.tabPanels = this.querySelectorAll('.tabbed-info__tabpanel');
    this.measurementsToggle = this.querySelectorAll('.tabbed-info__measurements-input');

    if (this.measurementsToggle) {
      this.measurementsToggle.forEach((measurementToggle) => {
        measurementToggle.addEventListener('change', this.onToggleChange.bind(this));
      });
    }

    this.tabButtons.forEach((tabButton) => {
      tabButton.addEventListener('click', (event) => {
        this.tabButtonClickHandler(event);
      });
    });

    // Select the first tab and panel by default
    if (this.tabButtons.length > 0 && this.tabPanels.length > 0) {
      this.tabButtons[0].setAttribute('aria-selected', 'true');
      this.tabPanels[0].hidden = false;
    }
  }

  onToggleChange(event) {
    const panel = event.target.closest('.tabbed-info__tabpanel');
    const conversionsTable = panel.querySelector('.size-table--conversions');
    const measurementsTable = panel.querySelector('.size-table--measurements');
    const garmentDescription = panel.querySelector('.garment-description');
    const sizeDescription = panel.querySelector('.size-description');

    if (event.target.checked) {
      conversionsTable.hidden = true;
      measurementsTable.hidden = false;
      if (garmentDescription) {
        garmentDescription.hidden = false;
      }
      if (sizeDescription) {
        sizeDescription.hidden = true;
      }
    } else {
      conversionsTable.hidden = false;
      measurementsTable.hidden = true;
      if (garmentDescription) {
        garmentDescription.hidden = true;
      }
      if (sizeDescription) {
        sizeDescription.hidden = false;
      }
    }
  }


  tabButtonClickHandler(event) {
    const selectedTab = event.target;
    const selectedPanelId = selectedTab.getAttribute('aria-controls');

    this.tabButtons.forEach((tabButton) => {
      tabButton.setAttribute('aria-selected', 'false');
      tabButton.classList.remove('button--primary');
      tabButton.classList.add('button--secondary');
    });

    this.tabPanels.forEach((tabPanel) => {
      tabPanel.hidden = true;
    });

    selectedTab.setAttribute('aria-selected', 'true');
    selectedTab.classList.remove('button--secondary');
    selectedTab.classList.add('button--primary');
    this.querySelector(`#${selectedPanelId}`).hidden = false;
  }
}

customElements.define('tabbed-info', TabbedInfo);
}
